import React, { useRef, useState } from "react";
import { Box, Paper, Typography, Button, Alert } from "@mui/material";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import DeleteIcon from "@mui/icons-material/Delete";

interface PdfUploaderProps {
  onUpload: (file: File) => void;
  previewUrl?: string;
}

const PdfUploader: React.FC<PdfUploaderProps> = ({ onUpload, previewUrl }) => {
  const fileRef = useRef<HTMLInputElement>(null);
  const [fileName, setFileName] = useState<string | undefined>(previewUrl);
  const [error, setError] = useState<string | null>(null);

  const handleSelect = (file: File) => {
    if (file.type !== "application/pdf") {
      setError("Please upload a valid PDF file");
      return;
    }

    if (file.size > 10 * 1024 * 1024) {
      setError("PDF must be less than 10MB");
      return;
    }

    setError(null);
    setFileName(file.name);
    onUpload(file);
  };

  return (
    <Box>
      <Typography variant="subtitle1" sx={{ mb: 2, fontWeight: 600 }}>
        Upload Course PDF
      </Typography>

      <input
        type="file"
        hidden
        accept="application/pdf"
        ref={fileRef}
        onChange={(e) => e.target.files && handleSelect(e.target.files[0])}
      />

      <Paper
        onClick={() => fileRef.current?.click()}
        sx={{
          p: 3,
          textAlign: "center",
          border: "2px dashed #ccc",
          borderRadius: 2,
          cursor: "pointer",
        }}
      >
        <CloudUploadIcon sx={{ fontSize: 48, color: "#ccc", mb: 1 }} />
        <Typography>Click to upload PDF</Typography>

        {fileName && (
          <Typography sx={{ mt: 2 }}>
            <strong>Selected:</strong> {fileName}
          </Typography>
        )}
      </Paper>

      {fileName && (
        <Button
          color="error"
          startIcon={<DeleteIcon />}
          fullWidth
          sx={{ mt: 1 }}
          onClick={() => setFileName(undefined)}
        >
          Remove PDF
        </Button>
      )}

      {error && (
        <Alert severity="error" sx={{ mt: 2 }}>
          {error}
        </Alert>
      )}
    </Box>
  );
};

export default PdfUploader;
